import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Timestamp } from '@components/basics/Timestamp';
import { VerifiedTooltip } from '@components/main-components/tooltip/VerifiedTooltip';
import { SPACE } from '@utils/constants';

export const FeedActivityContainer = ({
  children,
  timestamp,
  className,
}: {
  children: React.ReactNode;
  timestamp: string | number;
  className?: string;
}) => {
  return (
    <div
      className={twMerge(
        ' flex w-full items-center justify-between py-3 text-base-s md:border-b md:border-base200 md:py-4 md:text-base-m lg:text-base-l',
        className,
      )}
    >
      {children}
      <Timestamp timeStamp={timestamp} className="!text-base-xs text-base400" />
    </div>
  );
};

export const FeedListUsername = ({
  username,
  isArtist,
}: {
  username: string;
  isArtist: boolean;
}) => {
  return (
    <div className="inline-flex items-center">
      <span className="max-w-[110px] overflow-hidden text-ellipsis whitespace-nowrap font-semibold text-base800 2xl:max-w-[250px]">
        {username}
      </span>
      {isArtist && (
        <>
          {SPACE}
          <span className="hidden md:block">
            <VerifiedTooltip />
          </span>
          <span className="block md:hidden">
            <VerifiedTooltip size={12} />
          </span>
        </>
      )}
      {SPACE}
    </div>
  );
};
